import axios from 'axios';
import jsonlint from '../../jsonlint'
//测试环境
 let baseUrl = 'http://www.chintyy.com/center'
//本地环境
// const baseUrl = 'http://10.121.12.128:8080/center'
// const baseUrl = 'http://10.121.8.1:80/center'
//生产环境 (发布使用)
//let baseUrl = 'https://www.empowerchint.com/center'
if(process.env.NODE_ENV === 'test'){
    baseUrl = 'http://www.chintyy.com/center'
} else if(process.env.NODE_ENV === 'production'){
    baseUrl = 'https://www.empowerchint.com/center'
}
const requset = axios.create({
    baseUrl :baseUrl,
    transformResponse: [function (data) {
        return jsonlint.parse(data)
      }]

})
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ],

    }).then(res => res.data);
};




const forumreq = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ],
        //表情和id兼容处理
        transformResponse: [function (data) {
            let urlAdds = url.slice(34,39)
            let ret = jsonlint.parse(data)
            let jsonDataM = JSON.parse(data).data
            if(urlAdds=='/show'){
                ret.data.modelList.forEach((element,index) => {
                    element.message = jsonDataM.modelList[index].message
                    let jsonDataReplyDTOS=jsonDataM.modelList[index].replyDTOS
                    element.replyDTOS.forEach((item,i) => {
                        item.content = jsonDataReplyDTOS[i].content
                    })
                });
                return ret
            }else{
                return jsonlint.parse(data)
            }
          }]
    }).then(res => res.data);
};
const req = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ],
    }).then(res => res.data);
};
// 通用公用方法
const mapbaseUrl = 'https://restapi.amap.com/v3'
const mapreq = (method, url, params) => {
    return axios({
        method: method,
        url: mapbaseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

// 支付公用方式
const alipayReq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function (data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};

const ztreq = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        transformResponse: [function (data) {
            return jsonlint.parse(data)
          }],
        headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true
    }).then(res => res.data);
};

const bolbreq = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            responseType: 'arraybuffer'
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const fileUploadReq = (method, url, params) => {
  console.log(method,url,params)
  return axios({
    method: method,
    url: baseUrl + url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: params,
    traditional: true,
  }).then(res => res.data)
}


export {
    loginreq,//登录请求方法
    req,//常规请求方法
    mapreq,//通用请求方法
    forumreq,//论坛功能请求方法 以上请求头统一是'Content-Type': 'application/x-www-form-urlencoded'
    alipayReq,//支付请求方法 以下请求头统一是 'Content-Type': 'application/json',
    ztreq,
    bolbreq,
    baseUrl,
    fileUploadReq,
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js